import { Problema } from 'graphql/types.generated'

import { CIAPS_GESTACAO_CODIGOS, CIDS_GESTACAO_CODIGOS } from '../../soap/pre-natal/model-preNatal'

export const sortProblemasPreNatal = (a: Problema, b: Problema) => {
  const aIsInPreNatal = CIAPS_GESTACAO_CODIGOS.has(a.ciap?.codigo) || CIDS_GESTACAO_CODIGOS.has(a.cid10?.codigo)
  const bIsInPreNatal = CIAPS_GESTACAO_CODIGOS.has(b.ciap?.codigo) || CIDS_GESTACAO_CODIGOS.has(b.cid10?.codigo)

  if (aIsInPreNatal && !bIsInPreNatal) {
    return -1
  }

  if (!aIsInPreNatal && bIsInPreNatal) {
    return 1
  }

  return 0
}
